import axios from "axios";
import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getUserWallet = () => {
  return http.get(
    `${getBaseUrl()}/person_wallet`
  );
};

export const getUserWalletProductLog = () => {
  return http.get(
    `${getBaseUrl()}/person_wallet_product_log`
  );
};

export const getPersonWalletChange = () => {
  return http.get(
    `${getBaseUrl()}/person_wallet_change`, {
      responseType: 'blob',
    }
  );
};

export const getPersonWithdrawal = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/person_withdrawal`
    );
  }
  return http.get(
    `${getBaseUrl()}/person_withdrawal?${paginate}`
  );
};

export const getNewWithdrawal = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/new_withdrawal`
    );
  }
  return http.get(
    `${getBaseUrl()}/new_withdrawal?${paginate}`
  );
};

export const submitWalletWithdrawal = (data) => {
  return axios.post(
    `${getBaseUrl()}/withdrawal`,
    data,
    {validateStatus: () => true, skipSuccessToast: true}
  );
};

export const getWithdrawalAvailableSources = () => {
  return axios.get(
    `${getBaseUrl()}/withdrawal_available_sources`,
    {validateStatus: () => true}
  );
};

export const updateWalletWithdrawal = (data) => {
  return http.put(
    `${getBaseUrl()}/withdrawal/${data.id}`, 
    data
  );
};

export const uploadWithdrawalReceipt = (id, file) => {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("receipt", file);

  http.hasFile();

  return http.put(
    `${getBaseUrl()}/withdrawal/receipt`,
    formData
  );
};
